import { useQuery, keepPreviousData } from '@tanstack/react-query';
import apiClient from './apiClient';

export const materialReportKeys = {
  all: ['materialReports'],
  report: (view, filters) => ['materialReports', view, filters],
};

let reportRevision = 0;

/** Una mutación exige un cálculo nuevo, incluso si la API usa varios procesos. */
export const invalidateMaterialReports = (client) => {
  reportRevision = Math.max(reportRevision + 1, Date.now());
  return client.invalidateQueries({ queryKey: materialReportKeys.all });
};

/** Consulta importes calculados por backend con un único corte de valoración. */
export const useMaterialReports = (view, filters = {}, options = {}) =>
  useQuery({
    queryKey: materialReportKeys.report(view, filters),
    queryFn: async () => {
      const params = Object.fromEntries(
        Object.entries(filters).filter(([, value]) => value !== '' && value != null)
      );
      if (reportRevision) {
        params.refreshed_at = Math.max(Number(params.refreshed_at) || 0, reportRevision);
      }
      if (params.column_filters) params.column_filters = JSON.stringify(params.column_filters);
      return (await apiClient.get(`material_reports/${view}`, { params })).data;
    },
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
    ...options,
  });
